import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import styles from './styles';

const NotFound = props => {
	const {classes} = props;

	return (
		<div className={classes.container}>
			<h1 className={classes.title}>404</h1>
			<p>Page not found</p>
		</div>
	);
};

NotFound.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NotFound);



// WEBPACK FOOTER //
// ./src/client/components/not-found/index.jsx